import React from 'react';
import App from './App';
import RemoteService from './RemoteService';

const url = new URLSearchParams(document.location.search);
const showAdvanced = url.get('show-advanced') === 'true';
const rs = new RemoteService();

export function makeAppRoot() {
    return <App rs={rs} showAdvanced={showAdvanced} />;
}
